import { Link } from 'react-router-dom'

const NavLogoButton = () => {
  return (
    <div className="flex items-center">
      <Link to="/">
        <img
          src={`${import.meta.env.VITE_ASSET_URL || ''}/blogging-dev.svg`}
          alt="blogging.dev logo"
          className="h-12 w-[199px] dark:brightness-0 dark:invert"
        />
      </Link>
    </div>
  )
}

export default NavLogoButton
